<template>
  <div>
    <el-checkbox style="margin-bottom: 16px;" v-model="warnState" :true-label="1" :false-label="0">警告通知</el-checkbox>
    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 40}" v-model="msg" maxlength="200" placeholder="请输入1000字以内的小助手通知消息"/>
    <div style="margin: 16px 0 8px;">
      <el-checkbox v-model="check1" @change="checkChange(1)">{{msg1}}</el-checkbox>
      <el-checkbox v-if="to == 1" v-model="check2" @change="checkChange(2)">{{msg2}}</el-checkbox>
    </div>
    <div class="dialog-footer" style="text-align: left;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">发送通知</el-button>
    </div>
    <div style="margin-top: 16px;">
      <el-checkbox v-model="handled">该举报标为“已处理”</el-checkbox>
      <el-checkbox v-if="to == 1" v-model="notice">发送通知给举报人：{{msg3}}</el-checkbox>
    </div>
  </div>
</template>

<script>
import {sendSystemMessage, updateReportState} from "@/api/url";
import { postFormData } from "@/api/api";

export default {
  name: "SendSystemMessage",
  props: {
    value: Object
  },
  data() {
    return {
      to: this.value.to,
      idArray: this.value.idArray,
      userIdArray: this.value.userIdArray, //举报人
      toUserIdArray: this.value.toUserIdArray, //被举报人
      msg: '',
      msg1: this.value.to == 1?'最近你存在被用户举报的记录，请遵守平台规则，再次违规将会被禁言':'很感谢能够收到您的反馈信息，每一条举报信息，我们都十分重视。您提交的举报信息经过审核，我们现已对您举报的用户进行处理，感谢您的举报',
      msg2: '最近系统继续收到你被举报的记录，请遵守平台规则，再次违规将会被封号',
      msg3: '【匿名举报反馈】非常感谢你的举报，我们已对涉嫌违规账户进行了调查和处罚',
      loading: false,
      warnState: 0,
      check1: false,
      check2: false,
      handled: true,
      notice: true,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    checkChange(s) {
      if(s == 1) {
        this.check2 = false
        this.msg = this.msg1
      }
      if(s == 2) {
        this.check1 = false
        this.msg = this.msg2
      }
    },

    submit() {
      if ( !this.msg ) {
        this.$message({
          message: '通知内容不能为空',
          duration: 2000,
          type: 'warning'
        })
        return  false
      }
      this.loading = true
      let param = {}
      param['idArr'] = this.toUserIdArray
      param['content'] = this.msg
      param['warnState'] = this.warnState
      postFormData(sendSystemMessage, param).then((data) => {
        let {code, msg} = data;
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          if(this.handled) {
            this.updateState()
          }
          if(this.notice) {
            this.sendNotice()
          }
          this.$emit('confirm')
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },

    sendNotice() {
      let param = {}
      param['idArr'] = this.userIdArray
      param['content'] = this.msg3
      param['warnState'] = 0
      postFormData(sendSystemMessage, param).then((data) => {
        let {code, msg} = data;
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
      }).catch(()=>{
      })
    },

    updateState() {
      let _this = this;
      let param = {};
      param['idArr'] = this.idArray;
      param['state'] = 1;
      postFormData(updateReportState, param).then((data) => {
        let {code, msg} = data;
        if(code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
        }else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
        }
      })
          .catch(()=>{
          })
    },


  }

}
</script>

<style scoped>

</style>
